import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from "@denishussar/html5-game-engine";
import { FieldTypeConstants } from "../../Constants/FieldTypeConstants";
import { IFieldSize } from "../../Constants/FieldSizesConstants";
import { KykkaState } from "../../Constants/KykaState";
import { KykkaModel } from "../../Models/KykkaModel";

export interface IKykkaItemControllerwOptions {
    fieldType: FieldTypeConstants,
    fieldSize: IFieldSize
}
export class KykkaItemController extends AnimationBaseController {
    $model: KykkaModel;
    unitKoefX: number = 1;
    unitKoefY: number = 1;

    public constructor(@Inject private _options: IKykkaItemControllerwOptions) {
        super("KykkaItemController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            modelWatch: {
                rotationY: () => this._setByModel(),
                x: () => this._setByModel(),
                z: () => this._setByModel(),
                isActive: () => this._setByModel(),
            }
        }
    }

    protected onInitialize(): void {
        // this.x = this.$model.x;
        // this.y = this.$model.y;
        this.unitKoefX = 510 / this._options.fieldSize.width;
        this.unitKoefY = 283 / this._options.fieldSize.length;
        this._setByModel();
    }

    private _setByModel() {
        if (this.$model.isStanding) {
            this.gotoAndStop("circle");
        } else {
            this.gotoAndStop("square");
            this.rotation = -(this.$model.rotationZ);
        }
        const state = this.$model.state;
        this.visible = this.$model.isActive && !(state === KykkaState.OutCity || state === KykkaState.Guest);

        this.x = this.$model.x * this.unitKoefX;
        this.y = this.$model.z * this.unitKoefY;
        this.scaleX = 0.5;
        this.scaleY = 0.5;
    }
}